import React from "react";
import "./Main.css";
import { NavLink } from "react-router-dom";

const Main = () => {
  return (
    <div className="container-fluid">
      <div className="row Main ">
        <div className="col-md-12 DisplyFlex">
          <NavLink to={`/admin`} className="MainBtn my-3 my-md-0">
            Admin
          </NavLink>
          <NavLink to={`/creator`} className="MainBtn my-3 my-md-0">
            Creator
          </NavLink>
          <NavLink to={`/standard`} className="MainBtn my-3 my-md-0">
            Standard
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Main;
